import { FC } from 'react';
import { AlgorithmTargetItemSourceMappingSelect } from './AlgorithmTargetItemSourceMappingSelect';
import { AlgorithmSourceFormDataType } from '../sources/schema/types';
import type { AlgorithmMappingQueryDtoType } from '../mappings/schema/types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmTargetMapTypeSourceField.translations.json';
import type { AlgorithmTargetMappingSourceOption } from './ruleOptions/types';
import { AlgorithmTargetItemDbSourceMappingSelect } from './AlgorithmTargetItemDbSourceMappingSelect';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-target-map-type-source-field',
);
addTranslations(translations);

interface AlgorithmTargetMapTypeSourceFieldProps {
  index: number;
  sources?: AlgorithmSourceFormDataType[];
  mappings?: AlgorithmMappingQueryDtoType[];
  options: AlgorithmTargetMappingSourceOption[];
  areDbSources: boolean;
}

export const AlgorithmTargetMapTypeSourceField: FC<
  AlgorithmTargetMapTypeSourceFieldProps
> = (props) => {
  const { index, options, sources = [], mappings = [], areDbSources } = props;
  const { t } = useTranslation();
  const label = t('sourceItemCode.label');

  return areDbSources ? (
    <AlgorithmTargetItemDbSourceMappingSelect
      index={index}
      label={label}
      sources={sources}
      mappings={mappings}
    />
  ) : (
    <AlgorithmTargetItemSourceMappingSelect
      label={label}
      index={index}
      options={options}
    />
  );
};
